"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fromBitcoinResourcesRaw = exports.toBitcoinResourcesRaw = exports.fromBitcoinOutputRaw = exports.toBitcoinOutputRaw = exports.fromBitcoinInputRaw = exports.toBitcoinInputRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var wallet_btc_1 = __importDefault(require("./wallet-btc"));
function toBitcoinInputRaw(_a) {
    var address = _a.address, value = _a.value, previousTxHash = _a.previousTxHash, previousOutputIndex = _a.previousOutputIndex;
    return [
        address,
        value ? value.toString() : undefined,
        previousTxHash,
        previousOutputIndex,
    ];
}
exports.toBitcoinInputRaw = toBitcoinInputRaw;
function fromBitcoinInputRaw(_a) {
    var _b = __read(_a, 4), address = _b[0], value = _b[1], previousTxHash = _b[2], previousOutputIndex = _b[3];
    return {
        address: address || undefined,
        value: value ? new bignumber_js_1.BigNumber(value) : undefined,
        previousTxHash: previousTxHash || undefined,
        previousOutputIndex: previousOutputIndex
    };
}
exports.fromBitcoinInputRaw = fromBitcoinInputRaw;
function toBitcoinOutputRaw(_a) {
    var hash = _a.hash, outputIndex = _a.outputIndex, blockHeight = _a.blockHeight, address = _a.address, value = _a.value, rbf = _a.rbf, isChange = _a.isChange;
    return [
        hash,
        outputIndex,
        blockHeight,
        address,
        value.toString(),
        rbf ? 1 : 0,
        isChange ? 1 : 0,
    ];
}
exports.toBitcoinOutputRaw = toBitcoinOutputRaw;
function fromBitcoinOutputRaw(_a) {
    var _b = __read(_a, 7), hash = _b[0], outputIndex = _b[1], blockHeight = _b[2], address = _b[3], value = _b[4], rbf = _b[5], isChange = _b[6];
    return {
        hash: hash,
        outputIndex: outputIndex,
        blockHeight: blockHeight || undefined,
        address: address || undefined,
        value: new bignumber_js_1.BigNumber(value),
        rbf: !!rbf,
        isChange: !!isChange
    };
}
exports.fromBitcoinOutputRaw = fromBitcoinOutputRaw;
function toBitcoinResourcesRaw(r) {
    return {
        utxos: r.utxos.map(toBitcoinOutputRaw),
        walletAccount: r.walletAccount && wallet_btc_1["default"].exportToSerializedAccountSync(r.walletAccount)
    };
}
exports.toBitcoinResourcesRaw = toBitcoinResourcesRaw;
function fromBitcoinResourcesRaw(r) {
    return {
        utxos: r.utxos.map(fromBitcoinOutputRaw),
        walletAccount: r.walletAccount &&
            wallet_btc_1["default"].importFromSerializedAccountSync(r.walletAccount)
    };
}
exports.fromBitcoinResourcesRaw = fromBitcoinResourcesRaw;
//# sourceMappingURL=serialization.js.map